import React from 'react'
import GWPlaceHolder from '../../assets/gw_placeholder.png'

type Props = {
  wheelImageUrl?: string | null
  roleName?: string
}

export function WheelManagementImageCard({
  wheelImageUrl,
  roleName,
}: Props) {
  return (
    <div className="gw-wm__card">
      <h2 className="gw-wm__card-title">Growth Wheel Image</h2>
      <div className="gw-wm__image-layout">
        <div className="gw-wm__preview-img-wrap">
          <img
            src={wheelImageUrl || GWPlaceHolder}
            alt={`Growth wheel${roleName ? ` for ${roleName}` : ''}`}
            className="gw-wm__img-fit"
          />
        </div>
        <div className="gw-wm__image-meta">
          {roleName && (
            <div className="gw-wm__role-context">
              <p className="gw-wm__role-context-label">
                Configuring wheel for
              </p>
              <h3 className="gw-wm__role-context-name">{roleName}</h3>
            </div>
          )}
          <p className="gw-wm__framework-intro mb-2">
            This image appears on the Growth Wheel landing page. Upload a new
            image to replace the current one.
          </p>
          <p className="gw-wm__hint-sm mb-0">
            Recommended: Square image, minimum 800x800px, PNG or JPG format
          </p>
        </div>
      </div>
    </div>
  )
}
